export default __webpack_public_path__ + "static/icon-tile-light-c370dcf11af4903c9071e473abe45309.png";